/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PostPersonsPersonIdImpersonate201Response
 */
export interface PostPersonsPersonIdImpersonate201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostPersonsPersonIdImpersonate201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostPersonsPersonIdImpersonate201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof PostPersonsPersonIdImpersonate201Response
     */
    result: string;
}

/**
 * Check if a given object implements the PostPersonsPersonIdImpersonate201Response interface.
 */
export function instanceOfPostPersonsPersonIdImpersonate201Response(value: object): value is PostPersonsPersonIdImpersonate201Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function PostPersonsPersonIdImpersonate201ResponseFromJSON(json: any): PostPersonsPersonIdImpersonate201Response {
    return PostPersonsPersonIdImpersonate201ResponseFromJSONTyped(json, false);
}

export function PostPersonsPersonIdImpersonate201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsPersonIdImpersonate201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'],
    };
}

export function PostPersonsPersonIdImpersonate201ResponseToJSON(json: any): PostPersonsPersonIdImpersonate201Response {
    return PostPersonsPersonIdImpersonate201ResponseToJSONTyped(json, false);
}

export function PostPersonsPersonIdImpersonate201ResponseToJSONTyped(value?: PostPersonsPersonIdImpersonate201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': value['result'],
    };
}

